import React, {useEffect, useMemo} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {DsTooltip} from "@pg-design/floating-module";
import {calculateRemSize} from "@pg-design/helpers-css-strings";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text";

import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {useGetStatsQuery} from "../../api/configurator_api";
import {useRegionPriceSliderValues} from "../../hooks/use_region_price_slider_values";
import {useRegionsIds} from "../../hooks/use_regions_ids";
import {SearchFormValuesType} from "../../views/PropertyConfigurator";
import {BudgetFieldsNames} from "./FiltersForm";

interface IProps {
    values: SearchFormValuesType;
    onChange: (value: Partial<SearchFormValuesType>) => void;
}

export const BudgetFilter = ({...filterProps}: IProps) => {
    const price = useWatch({name: BudgetFieldsNames.TOTAL});
    const instalment = useWatch({name: BudgetFieldsNames.CREDIT});
    const radioType = useWatch({name: BudgetFieldsNames.RADIO});
    const {regionsIds} = useRegionsIds();
    const areRegionsEmpty = !regionsIds || regionsIds.length === 0;
    const {data} = useGetStatsQuery({regionsIds: regionsIds || []}, {skip: areRegionsEmpty});
    const {max} = useRegionPriceSliderValues(areRegionsEmpty ? undefined : data?.maxPrice);
    const maximum = useMemo(() => (max < price ? price : max), [max]);

    useEffect(() => {
        if (radioType === "total") {
            filterProps.onChange({price: {lower: "", upper: price.toString()}, instalment: 0});
        } else {
            filterProps.onChange({instalment: instalment, price: {lower: "", upper: ""}});
        }
    }, [price, instalment]);

    return (
        <BudgetField
            radioName={BudgetFieldsNames.RADIO}
            type="switch"
            totalInputName={BudgetFieldsNames.TOTAL}
            monthlyInputName={BudgetFieldsNames.CREDIT}
            totalMax={maximum}
            useBudgetDynamicStep
            monthlyTitleRender={() => (
                <div css={monthlyTitle} onClick={(e) => e.stopPropagation()}>
                    <Text variant="info_txt_1">Rata kredytu</Text>
                    <div onClick={(e) => e.stopPropagation()}>
                        <DsTooltip
                            popover="Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie 7% oraz okresie kredytowania wynoszącym 30 lat."
                            type="success"
                            css={messageTooltip}
                        >
                            {({refs, getReferenceProps}) => (
                                <div ref={refs.setReference} {...getReferenceProps()}>
                                    <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                                </div>
                            )}
                        </DsTooltip>
                    </div>
                </div>
            )}
        />
    );
};

const monthlyTitle = css`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: ${calculateRemSize(1)};
`;

const messageTooltip = css`
    z-index: 10000;
    max-width: 360px;
`;
import React, {useEffect, useMemo} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {DsTooltip} from "@pg-design/floating-module";
import {calculateRemSize} from "@pg-design/helpers-css-strings";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text";

import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {useGetStatsQuery} from "../../api/configurator_api";
import {useRegionPriceSliderValues} from "../../hooks/use_region_price_slider_values";
import {useRegionsIds} from "../../hooks/use_regions_ids";
import {SearchFormValuesType} from "../../views/PropertyConfigurator";
import {BudgetFieldsNames} from "./FiltersForm";

interface IProps {
    values: SearchFormValuesType;
    onChange: (value: Partial<SearchFormValuesType>) => void;
}

export const BudgetFilter = ({...filterProps}: IProps) => {
    const price = useWatch({name: BudgetFieldsNames.TOTAL});
    const instalment = useWatch({name: BudgetFieldsNames.CREDIT});
    const radioType = useWatch({name: BudgetFieldsNames.RADIO});
    const {regionsIds} = useRegionsIds();
    const areRegionsEmpty = !regionsIds || regionsIds.length === 0;
    const {data} = useGetStatsQuery({regionsIds: regionsIds || []}, {skip: areRegionsEmpty});
    const {max} = useRegionPriceSliderValues(areRegionsEmpty ? undefined : data?.maxPrice);
    const maximum = useMemo(() => (max < price ? price : max), [max]);

    useEffect(() => {
        if (radioType === "total") {
            filterProps.onChange({price: {lower: "", upper: price.toString()}, instalment: 0});
        } else {
            filterProps.onChange({instalment: instalment, price: {lower: "", upper: ""}});
        }
    }, [price, instalment]);

    return (
        <BudgetField
            radioName={BudgetFieldsNames.RADIO}
            type="switch"
            totalInputName={BudgetFieldsNames.TOTAL}
            monthlyInputName={BudgetFieldsNames.CREDIT}
            totalMax={maximum}
            useBudgetDynamicStep
            monthlyTitleRender={() => (
                <div css={monthlyTitle} onClick={(e) => e.stopPropagation()}>
                    <Text variant="info_txt_1">Rata kredytu</Text>
                    <div onClick={(e) => e.stopPropagation()}>
                        <DsTooltip
                            popover="Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie 7% oraz okresie kredytowania wynoszącym 30 lat."
                            type="success"
                            css={messageTooltip}
                        >
                            {({refs, getReferenceProps}) => (
                                <div ref={refs.setReference} {...getReferenceProps()}>
                                    <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                                </div>
                            )}
                        </DsTooltip>
                    </div>
                </div>
            )}
        />
    );
};

const monthlyTitle = css`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: ${calculateRemSize(1)};
`;

const messageTooltip = css`
    z-index: 10000;
    max-width: 360px;
`;
